export const auth0Config = {
  domain: "dev-w44ptuue38pcnkfg.us.auth0.com",
  clientId: "6cxjwOCMVLu53P2ugDpZgrn3vY8MrMXS",
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: "https://auth.clouseau.com/",
    scope: "openid profile email",
  },
};

export const tokenAuthorizationParams = {
  audience: "https://auth.clouseau.com/",
  scope: "openid profile email",
};
